module.exports = __webpack_public_path__ + "static/media/Sweden.2cd77050.png";